// Shared comparator for blog article listings that respect the global
// "Sort blog articles by" theme setting (Theme settings > Blog) - used by
// the homepage From The Blog section, the Blog Listing page, and the
// Resources page's article grid, so all three stay in sync with one choice.
window.ftSortArticleCards = function (cards, mode) {
  var isMetafield = mode === 'metafield';
  var keyAttr = mode === 'updated_at' ? 'data-updated-at' : isMetafield ? 'data-sort-order' : 'data-published-at';

  cards.sort(function (a, b) {
    var av = parseFloat(a.getAttribute(keyAttr));
    var bv = parseFloat(b.getAttribute(keyAttr));
    var aHas = !isNaN(av);
    var bHas = !isNaN(bv);

    if (isMetafield) {
      // Ascending (1, 2, 3...) - cards with no value fall to the end, keeping
      // their existing relative order (Shopify's default newest-first).
      if (!aHas && !bHas) return 0;
      if (!aHas) return 1;
      if (!bHas) return -1;
      return av - bv;
    }

    // published_at / updated_at are always present - descending (newest first).
    return bv - av;
  });

  return cards;
};
